import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { config } from '@uhg-abyss/web/tools/config';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Table as AbyssTable } from '@uhg-abyss/web/ui/Table';
import { isNull, isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';

/**
 * Table
 *
 * Displays change event information in a table.
 *
 * @param changeData
 * @returns {Element}
 * @constructor
 */
export function SplitMerge({ changeData = {} }) {
  const [changeEvents, setChangeEvents] = useState([]);

  /**
   * Format the change events data to output in a table.
   */
  useEffect(() => {
    const events = [];

    changeData?.changeEvents?.forEach((changeEvent) => {
      const event = { ...changeEvent };
      if (changeEvent?.changeType === 'SPLIT') {
        event.associatedSplitEids = changeData?.associatedSplitEids;
      }

      if (changeEvent?.changeType === 'MERGE') {
        if (isNull(changeData?.mergedInto)) {
          event.associatedMergedEids = changeData?.associatedMergedEids;
        } else {
          event.mergedInto = changeData?.mergedInto;
        }
      }

      events.push(event);
    });

    if (events !== changeEvents) {
      setChangeEvents(events);
    }
  }, [changeData]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/Eimp/components/SplitMerge/SplitMerge.jsx">
      <p>
        <strong>Split / Merge</strong>
      </p>
      <Layout.Group alignItems="top" alignLayout="left">
        {changeEvents?.map((changeEvent) => {
          return (
            <div className="static-table" key={`date-${changeEvent?.changeDate}`} style={{ minWidth: 400 }}>
              <AbyssTable.Container>
                <AbyssTable.TableBody>
                  <AbyssTable.Row>
                    <AbyssTable.Column css={{ minWidth: 200 }}>Change Type</AbyssTable.Column>
                    <AbyssTable.Cell>{changeEvent?.changeType}</AbyssTable.Cell>
                  </AbyssTable.Row>

                  <AbyssTable.Row>
                    <AbyssTable.Column css={{ minWidth: 200 }}>Change Date</AbyssTable.Column>
                    <AbyssTable.Cell>{dayjs(changeEvent?.changeDate).format('MM/DD/YYYY, HH:mm:ss')}</AbyssTable.Cell>
                  </AbyssTable.Row>

                  {!isUndefined(changeEvent?.associatedSplitEids) && (
                    <AbyssTable.Row>
                      <AbyssTable.Column css={{ minWidth: 200 }}>Associated Split EID's</AbyssTable.Column>
                      <AbyssTable.Cell>
                        {changeEvent?.associatedSplitEids?.map((eid, index) => {
                          return (
                            <React.Fragment key={`eid-${eid}`}>
                              <Link href={`${config('HCM_URL')}/${eid}/`} openNewWindow>
                                {eid}
                              </Link>
                              {index < changeEvent?.associatedSplitEids?.length - 1 && ', '}
                            </React.Fragment>
                          );
                        })}
                      </AbyssTable.Cell>
                    </AbyssTable.Row>
                  )}

                  {!isUndefined(changeEvent?.associatedMergedEids) && (
                    <AbyssTable.Row>
                      <AbyssTable.Column css={{ minWidth: 200 }}>Associated Merged EID's</AbyssTable.Column>
                      <AbyssTable.Cell>
                        {changeEvent?.associatedMergedEids?.map((eid, index) => {
                          return (
                            <React.Fragment key={`eid-${eid}`}>
                              <Link href={`${config('HCM_URL')}/${eid}/`} openNewWindow>
                                {eid}
                              </Link>
                              {index < changeEvent?.associatedMergedEids?.length - 1 && ', '}
                            </React.Fragment>
                          );
                        })}
                      </AbyssTable.Cell>
                    </AbyssTable.Row>
                  )}

                  {!isUndefined(changeEvent?.mergedInto) && (
                    <AbyssTable.Row>
                      <AbyssTable.Column css={{ minWidth: 200 }}>EID Merged Into</AbyssTable.Column>
                      <AbyssTable.Cell>
                        <Link
                          href={`${config('HCM_URL')}/${changeEvent?.mergedInto}/`}
                          key={`eid-${changeEvent?.mergedInto}`}
                          openNewWindow
                        >
                          {changeEvent?.mergedInto}
                        </Link>
                      </AbyssTable.Cell>
                    </AbyssTable.Row>
                  )}
                </AbyssTable.TableBody>
              </AbyssTable.Container>
            </div>
          );
        })}
      </Layout.Group>
    </ErrorHandler>
  );
}
